import { Component, input, Input, OnInit } from '@angular/core';
import { CardType } from 'src/app/enums/card-type';
import { Project } from 'src/app/interfaces/project';
import { Survey } from 'src/app/interfaces/survey';
import { ParticipationService } from 'src/app/services/participation.service';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CardComponent } from '../../../../components/cards/card/card.component';
import { NgIf } from '@angular/common';
import { StateNoticeComponent } from '../../../../components/state-notice/state-notice.component';

@Component({
  selector: 'app-project-participate',
  templateUrl: './project-participate.component.html',
  standalone: true,
  imports: [
    NgIf,
    CardComponent,
    InlineSVGModule,
    TranslateModule,
    StateNoticeComponent,
  ],
})
export class ProjectParticipateComponent implements OnInit {
  public readonly project = input.required<Project>();
  public readonly hide = input.required<boolean>();
  public CardType = CardType;

  constructor(private participationService: ParticipationService) {}

  ngOnInit() {
    this.participationService.updateLastViewData(this.project());
  }
}
